// YouTube URL → 11-char video ID extractor.
// Supports: youtu.be/<id>, youtube.com/watch?v=<id>, youtube.com/embed/<id>,
//            youtube.com/v/<id>, youtube.com/shorts/<id>, m.youtube.com/*, with extra params.
export function extractYoutubeId(input) {
  if (!input) return '';
  const trimmed = String(input).trim();
  // Already an 11-char ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;
  const re = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const m = trimmed.match(re);
  return m ? m[1] : '';
}

export function youtubeThumb(id, quality = 'hqdefault') {
  if (!id) return '';
  return `https://img.youtube.com/vi/${id}/${quality}.jpg`;
}

// Build an embed URL with all our preferred theatre flags.
// Note: `mute=1` lets autoplay succeed on mobile browsers (they all block sound on autoplay).
export function youtubeEmbedUrl(id, opts = {}) {
  if (!id) return '';
  const params = new URLSearchParams({
    autoplay: opts.autoplay ? '1' : '0',
    mute: opts.muted ? '1' : '0',
    controls: opts.controls === false ? '0' : '1',
    rel: '0',              // restrict related videos to same channel
    modestbranding: '1',   // hide YouTube logo where allowed
    playsinline: '1',      // iOS: keep video inline, no fullscreen takeover
    enablejsapi: '1',      // allow postMessage control
    origin: typeof window !== 'undefined' ? window.location.origin : '',
  });
  return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
}
